<template>
  <div :class="['flex flex-col mb-4', classes]">
    <q-input
      v-bind="$attrs"
      v-model="value"
      :disable="isDisabled"
      bg-color="#fff"
      :placeholder="placeholder"
      class="text-text-primary">
      <template v-for="(_, name) in $slots" #[name]="slotProps">
        <slot :name="name" v-bind="slotProps || {}" />
      </template>
    </q-input>
    <div v-if="isPresent(errorMessage)" class="mt-3 text-xs text-text-danger-tertiary">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import { useField } from 'vee-validate';
import { isPresent } from '@/utils/lang';

interface Props {
  initialValue?: string | number | null;
  name: string;
  showErrors?: boolean;
  placeholder?: string;
  classes?: string[];
  isDisabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  initialValue: null,
  showErrors: true,
  placeholder: '',
  classes: () => [],
  isDisabled: false,
});

const { name, initialValue = null, isDisabled } = toRefs(props);

const { value, errorMessage } = useField<string | number | null>(name.value);
if (initialValue?.value !== null) {
  value.value = initialValue?.value ?? null;
}
</script>

<style lang="postcss" scoped>
@reference "tailwindcss";

:deep(.q-field) {
  .q-field__control {
    @apply !h-[40px]
        !rounded-[8px]
        !border
        !border-solid
        !border-[#d9d9d9]
        !p-0
        !shadow-none
        before:!border-none;
  }
  .q-field__marginal {
    @apply h-[40px];
  }

  .q-field__native {
    @apply !px-4 !py-2 !text-sm !font-normal !text-[#0D0D0D];

    &::placeholder {
      @apply !text-[#9A9A9F];
    }
  }
}
</style>
